import {Component} from '@angular/core';

import {AbstractCustomPropertyView} from '../abstract-custom-property-view';

@Component({
  selector: 'ax-custom-rich-text-view',
  templateUrl: './custom-rich-text-view.component.html',
})
export class CustomRichTextViewComponent extends AbstractCustomPropertyView {}
